
import { useParams, useSearchParams } from "react-router-dom";
import store from "../util/store.jsx";
import locationInfo from "../data/locationInfo.json";
import { ModeSelectionChoiceView } from "../views/modeSelectionChoiceView.jsx";
import { ModeSelectionGameView } from "../views/modeSelectionGameView.jsx";
import {categoryRoutes} from "../data/gameList.js"

function ModeSelection() {
  const { id } = useParams();
  const state = store.getState();
  const { userProgress } = state.userData;
  const { stockholm } = userProgress;
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedMode = searchParams.get("mode");

  const locTitle = locationInfo[id].title;
  const locProgress = stockholm[id];
  const imageKey = `drawing_${id}`;
  const timeCount = Object.keys(locProgress?.time || {}).length;
  const spaceCount = Object.keys(locProgress?.space || {}).length;

  const timeProgress = (timeCount / 4) * 100;
  const spaceProgress = (spaceCount / 4) * 100;

  function handleSelectedQuestACB(game) {

    const route = categoryRoutes[game];

    if (route) {
      window.location.hash = `#/${route}/${id}/${selectedMode}`;
    } else {
      console.error("Unknown category:", selectedMode, game);
    }
  }

  const handleModeClickACB = (mode) => {
    setSearchParams({ mode });
  };

  if (!selectedMode) {
    return (
      <ModeSelectionChoiceView
        timeProgress={timeProgress}
        spaceProgress={spaceProgress}
        handleModeClickACB={handleModeClickACB}
        locTitle={locTitle}
        imageKey={imageKey}
      />
    );
  }

  return (
    <ModeSelectionGameView
      selectedMode={selectedMode}
      locTitle={locTitle}
      locProgress={locProgress}
      imageKey={imageKey}
      onGameClickACB={handleSelectedQuestACB}
    />
  );
}

export { ModeSelection };
